export default __webpack_public_path__ + "static/media/image1pro4.2d9d20ee.jpeg";